export const MONITOR_TYPES = {
    SERVER: 'SERVER',
    HEARTBEAT: 'UPTIME',
    MONGO: 'MONGO'
};
